export default "__VITE_ASSET__JwkS4vje__"